import classNames from "classnames";
import type { BlockProps } from "./Block";
import { Block } from "./Block";

export interface SmallRectangleProps extends BlockProps {}

export const SmallRectangle = ({ className, ...rest }: SmallRectangleProps) => (
  <Block className={classNames("h-2 rounded-sm", className)} {...rest} />
);
